import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { Grid } from '@chakra-ui/react';
import { isGroupedColumn } from '../../SimpleTable.utils';
import { TableColumn } from './components';
const TableHeaderFC = ({ flattenColumns, baseColumns, noBg }) => {
    const isGrouped = useMemo(() => baseColumns.some((col) => isGroupedColumn(col)), [baseColumns]);
    const getHeaderStyles = useCallback((column, isFirst, isLast) => {
        const baseStyles = {
            position: column.sticky ? 'sticky' : 'static',
            top: 0,
            alignContent: 'center',
            borderBottom: '1px solid',
            minH: '36px',
            bg: noBg ? 'white' : 'bg',
            justifyItems: isGrouped ? 'center' : (column.align ?? 'center'),
            zIndex: column.sticky ? 2 : 1,
            paddingLeft: '4px',
            paddingRight: '4px',
            gridColumn: isGroupedColumn(column) ? `span ${column.items.length}` : 0,
            borderRight: isGrouped ? `1px solid` : 'unset'
        };
        if (isFirst) {
            baseStyles.left = 0;
            baseStyles.borderLeft = 0;
            baseStyles.borderRight = column.sticky ? `1px solid` : 'unset';
        }
        if (isLast) {
            baseStyles.right = 0;
            baseStyles.borderRight = 0;
            baseStyles.borderLeft = column.sticky ? `1px solid` : 'unset';
        }
        baseStyles.borderColor = 'border';
        return baseStyles;
    }, [isGrouped, noBg]);
    const templateColumns = useMemo(() => {
        return (flattenColumns || [])
            .map((col) => col.width ?? `minmax(90px, ${col.columnTemplate ?? '1fr'})`)
            .join(' ');
    }, [flattenColumns]);
    return (_jsxs(Grid, { templateColumns: templateColumns, position: "sticky", top: 0, zIndex: 2, children: [isGrouped &&
                baseColumns.map((column, idx) => (_jsx(TableColumn, { name: isGroupedColumn(column) ? column.name : '', columnNode: column.renderHeader?.(column), columnSx: {
                        ...getHeaderStyles(column, idx === 0, idx === baseColumns.length - 1)
                    } }, 'group_' + idx))), flattenColumns.map((column, idx) => (_jsx(TableColumn, { name: column.name, columnNode: column.renderHeader?.(column), columnSx: {
                    ...getHeaderStyles(column, idx === 0, idx === flattenColumns.length - 1)
                } }, column.propertyName ?? idx)))] }));
};
export const TableHeader = memo(TableHeaderFC);
//# sourceMappingURL=TableHeader.js.map